import useSWR from "swr";
import { getOpenEvent } from "../jiraya_helper";
import { GET_EVENT_OPEN } from "../jiraya_url";

/**
 * Custom hook to fetch event details
 * @param {string|number} eventId - The event ID to fetch
 * @param {string} eventKey - Optional event key for authentication
 * @returns {Object} - Event data, loading state, and error state
 */
export default function useEvent(eventId) {
  const { data, error, mutate, isLoading } = useSWR(
    eventId ? [GET_EVENT_OPEN, eventId] : null,
    () => getOpenEvent({ params: { event_id: eventId } }),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  return {
    eventData: data?.data || null,
    isLoading: isLoading || (!error && !data),
    isError: error,
    mutate,
    event: data?.data || null,
  };
}
